import apiClient from './apiClient';

export const getAbout = async () => {
  const { data } = await apiClient.get('/api/about');
  return data && typeof data === 'object' ? data : null;
};

export const saveAbout = async (payload) => {
  const { data } = await apiClient.put('/api/about', payload);
  return data;
};

